import { render, staticRenderFns } from "./ConceptoGeneralVisita.vue?vue&type=template&id=e88fbf9e&scoped=true&"
import script from "./ConceptoGeneralVisita.vue?vue&type=script&lang=js&"
export * from "./ConceptoGeneralVisita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88fbf9e",
  null
  
)

export default component.exports